import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { AlertController, NavController, LoadingController, ToastController } from '@ionic/angular';

import { Salon } from '../../models';
import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';
import { Utilities } from '../../utilities/utilities';
import { Router } from '@angular/router';
@Component({
  selector: 'smr-pos-settings',
  templateUrl: './pos-settings.page.html',
  styleUrls: ['./pos-settings.page.scss'],
})
export class PosSettingsPage implements OnInit {

  public salon: Salon;

  public isLoading: boolean;

  public errorOccured: boolean;

  public enablePOSToggle: UntypedFormControl;

  public enablePOSForm: UntypedFormGroup;

  public isAdmin: boolean;

  constructor (private navCtrl: NavController,
               private userService: UserService,
               private salonService: SalonService,
               private formBuilder: UntypedFormBuilder,
               private alertController: AlertController,
               private loadingCtrl: LoadingController,
               private toastController: ToastController,
               private router: Router
  ) {
    this.isAdmin = this.userService.getUser().isAdministrator();
    this.enablePOSToggle = new UntypedFormControl(false);
    this.enablePOSForm = this.formBuilder.group({
      enablePOSToggle: this.enablePOSToggle
    });
  }


  public ngOnInit () {
    this.loadSalonInfo();
  }

  public loadSalonInfo () {
    this.isLoading = true;
    this.errorOccured = false;
    this.salonService.load()
        .subscribe({next: (salon: Salon) => {
              this.userService.setSalon(salon);
              this.salon = salon;
              this.enablePOSToggle.setValue(this.salon.getEnablePOS() === 1);
              this.isLoading = false;

            },
            error: (err) => {
              this.isLoading = false;
              this.errorOccured = true;
    }});
  }

  public async save () {
    if (!this.enablePOSForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({spinner: 'crescent'});
    loader.present();
    this.salon = this.salon.setEnablePOS(this.enablePOSToggle.value ? 1 : 0);
    this.salonService.saveSalon(this.salon)
        .subscribe({next: (salon: Salon) => {
              this.salon = salon;
              this.userService.setSalon(this.salon);
              loader.dismiss().then(() => {
                this.navCtrl.pop().then(async () => {
                  const toast = await this.toastController.create({
                    message: 'POS Settings has been updated',
                    duration: 3000
                  })
                  toast.present();
                });
              });
            },
            error: (err) => {
              loader.dismiss().then(() => {
                this.alertController.create(Utilities.getDefaultErrorMessageConfig());
              });
            }});
  }

}
